import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    profileDialog: {
      '&.paper': {
        minWidth: '85%',
        minHeight: '90%',
      },
    },
    profileDialog_Container: {
      minWidth: '86%',
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(2),
      minHeight: '90%',
      [theme.breakpoints.down('md')]: {
        minWidth: '90%',
      },
      [theme.breakpoints.down('lg')]: {
        minWidth: '95%',
      },
    },
    contentContainer: {
      marginTop: 12,
    },
    dialogContaier: {
      flex: '1 1 auto',
      padding: '40px !important',
    },
    closeCls: {
      position: 'absolute',
      width: '14px',
      height: '14px',
      right: '20px',
      top: '20px',
      '& path': {
        fill: theme.palette.type === 'dark' ? 'unset' : theme.palette.customGrey.dark,
      },
    },
  }),
);
